const Pdf_contract_template = (partner_data) => {
  return `
	  <div>
	  <div style="width: 100%; display:grid; place-items:center">
	    <h2 style=" text-indent: 0pt; text-align: left">
		 LALLATY
	    </h2>
	    </div>
	    <p style="padding-left: 18pt; text-indent: 0pt; text-align: left">
		 <a href="https://www.lallaty.com/" className="a" target="_blank"
		   >www.lallaty.com</a
		 ><a
		   href="mailto:partenaires@lallaty.ma"
		   style="
			color: #00c;
			font-family: 'Times New Roman', serif;
			font-style: normal;
			font-weight: normal;
			text-decoration: none;
			font-size: 9pt;
		   "
		   target="_blank"
		 >
		 </a
		 ><a href="mailto:partenaires@lallaty.ma" target="_blank"
		   >partenaires@lallaty.ma</a
		 >
	    </p>
	    <p style="padding-left: 18pt; text-indent: 0pt; text-align: left">
		 zenith buisness center ETG 3 N14 40000 - Marrakech, Maroc
	    </p>
	    <h1 style="padding-left: 45pt; text-indent: 0pt; text-align: center; margin-top:50px">
		 Convention de Partenariat
	    </h1>
	    <table
		  style="border-collapse: collapse; margin-left: 6.141pt; margin-top:30px;  margin-bottom:30px"
		  cellspacing="0"
		>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Detail de la société
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				PARTENAIRE
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				LALLATY
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Nom de la société
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				KOOP MASTER
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Réducte
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				ICE
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				003104105000075
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				003030945000087
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" 	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Nom de représentant
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" 	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Youssef elabid
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style=" 	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				MDAGHRI ALAOUI Zakaria
			  </p>
			</td>
		  </tr>
		  <tr style="height: 29pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  padding-right: 10pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Fonction du représentant
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p style="text-indent: 0pt; text-align: left"><br /></p>
			  <p
				className="s3"
				style=" 	padding: 20px;padding-left: 7pt; text-indent: 0pt; text-align: left"
			  >
				Gérant
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p style="text-indent: 0pt; text-align: left"><br /></p>
			  <p
				className="s3"
				style="	padding: 20px; padding-left: 7pt; text-indent: 0pt; text-align: left"
			  >
				CEO
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Téléphone
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				0648484838
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				0663 161 043
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Email
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				<a href="mailto:${partner_data.email}" className="s4">${partner_data.email}</a>
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				<a href="mailto:partenaires@lallaty.ma" className="s4"
				  >partenaires@lallaty.ma</a
				>
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Adresse de la société
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				${partner_data.adrress}
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Zenith buisness center etg3 n14
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="
				padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Ville
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="	padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				${partner_data.ville_name}
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Marrakech
			  </p>
			</td>
		  </tr>
		  <tr style="height: 19pt">
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="
				padding: 20px;
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
				Offre
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
				border-bottom-style: solid;
				border-bottom-width: 1pt;
				border-right-style: solid;
				border-right-width: 1pt;
			  "
			>
			  <p
				className="s3"
				style="
				  padding-top: 3pt;
				  padding-left: 7pt;
				  text-indent: 0pt;
				  text-align: left;
				"
			  >
			   ${partner_data.offer}
			  </p>
			</td>
			<td
			  style="
				border-top-style: solid;
				border-top-width: 1pt;
				border-left-style: solid;
				border-left-width: 1pt;
			  "
			>
			  <p style="text-indent: 0pt; text-align: left"><br /></p>
			</td>
		  </tr>
		</table>
	<ul style = "display : flex; flex-direction : column; gap: 10px;">
	    <p style=" text-indent: 0pt; text-align: left">
		 Nous nous engageons à fournir au partenaire mentionné ci-dessus un
		 affichage de son logo et informations de contact sur notre site web et
		 notre application mobile gratuitement au niveau de la section réservée aux
		 partenaires pour une durée indéterminée.
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Le partenaire mentionné ci-dessus s’engage à accepter tout client
		 provenant de la part de LALLATY.
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Le partenaire mentionné ci-dessus s’engage à respecter l&#39;offre
		 mentionnée ci-dessus vis-à-vis de tous les clients provenant de la part de
		 LALLATY dont l&#39;abonnement est actif.
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Le partenaire mentionné ci-dessus s’engage à afficher un autocollant
		 fourni par LALLATY mettant en avant son partenariat avec LALLATY
		 (dimensions de l’autocollant 10 cm x 15 cm).
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Le partenaire s’engage à respecter la confidentialité des clients en
		 s&#39;abstenant de divulguer les informations de ces derniers obtenu de
		 l&#39;interface partenaires LALLATY.
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Le partenaire mentionné ci-dessus s’engage à ne pas appliquer l&#39;offre
		 mentionné ci-dessus à des clients dont l’abonnement est expiré. L’accord
		 qui lie les deux parties peut-être résilié à tout moment à condition de
		 respecter la période de préavis de 15 jours, l&#39;envoi du préavis devra
		 se faire par e-mail.
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Le partenaire mentionné ci-dessus s’oblige à communiquer toute information
		 nécessaire au bon fonctionnement de LALLATY et de respecter les conditions
		 de travail de REDUCT
	    </p>

	    <p style=" text-indent: 0pt; text-align: left">
		 Tout point non traité sera traité par la législation en vigueur NB: Le
		 retour de ce courriel vaut acceptation.
	    </p>
	    </ul>
	    <p style="text-indent: 0pt; text-align: left"><br /></p>
	    <h4 style="text-indent: 0pt; text-align: right">
		 ${` A MARRAKECH &nbsp  &nbsp Le  &nbsp ${new Date()
       .toJSON()
       .slice(0, 16)
       .replace("T", " ")}`}
	    </h4>
	    <p style="text-indent: 0pt; text-align: left"><br /></p>
	    <p
		 style="
		   padding-top: 4pt;
		   padding-left: 45pt;
		   text-indent: 0pt;
		   text-align: center;
		 "
	    >
		 ZAKARIA MDAGHRI ALAOUI
	    </p>
	    <p style="padding-left: 45pt; text-indent: 0pt; text-align: center">
		 Représentant de LALLATY
	    </p>
	    <div style="display : flex; flex-direction: row; justify-content : space-between; align-items: center;">
	    <p style="text-indent: 0pt; text-align: left"><br /></p>
		 <p className="s5" target="_blank"
		   >Tel: 06 63 16 10 43 , </p
		 >
	    <p href="mailto:partenaires@lallaty.ma" className="s5" target="_blank"
		   > Email: partenaires@lallaty.ma</p
		 >
	    <a href="www.lallaty.com" className="s5" style="text-color: blue;">www.lallaty.com</a>
		</div>
	    <p style="padding-left: 45pt; text-indent: 0pt; text-align: center">
		 zenith buisness centre etg 3 n14 Marrakech maroc - ICE: 003030945000087 </br>
		 RC: 123941 IF: 51832067 CNSS: 4089085
	    </p>
	  </div>`;
};

export { Pdf_contract_template };
